import { useState, useEffect } from 'react';

/**
 * SafeEmail — Cloudflare Obfuscation Bypass Component
 * 
 * Prevents Cloudflare from modifying mailto: links in pre-rendered static HTML,
 * which eliminates React hydration mismatches and prevents the broken "email-protection" redirect page.
 * Renders a plain-text placeholder during pre-rendering/SSR, then smoothly upgrades to 
 * a fully functional mailto link once mounted in the user's browser.
 */
export default function SafeEmail({ 
  user = 'crew', 
  domain = 'hashq.in', 
  className = '', 
  children 
}) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const email = `${user}@${domain}`;

  if (!isMounted) {
    // Initial server render (and pre-rendering): Cloudflare won't detect this as an email because
    // it doesn't have an @ sign or mailto: structure in the HTML.
    return (
      <span className={className}>
        {children || `${user} [at] ${domain}`}
      </span>
    );
  }

  // Client-side render: fully functional mailto link, safe from Cloudflare interception
  return (
    <a href={`mailto:${email}`} className={className}>
      {children || email}
    </a>
  );
}
